import { getTokenDefinition, } from "@bracket/chainography";
import { Button, Text, Typography, themed, } from "@bracket/ui";
import { Div, Box, Flow, Stream, FlexStream,  } from "@bracket/ui/nodes";
import { getTheme, } from "@bracket/ui/themes";
import { WalletStoreConnector, } from "@components";
import { useAddNotification, useWallet, } from "@store";
import { SettingsBar, } from "client/components/SettingsBar";
import styled from "styled-components";

export declare type PageHeaderCustomProps = {
	customHeader: React.ReactNode;
	icon?: never;
	title?: never;
	description?: never;
	selector?: never;
	direction?: never;
	right?: never;
};

export declare type PageHeaderDefaultProps = {
	customHeader?: never;
	icon: React.ReactNode;
	title: string;
	description?: string;
	selector?: React.ReactNode;
	direction?: "horizontal" | "vertical";
	right?: React.ReactNode;
};

export declare type PageHeaderProps = PageHeaderCustomProps | PageHeaderDefaultProps;


const BrkEthValue = () => {

	const { ready, brkt_conv_rate, eth_price, anonymous, } = useWallet();
	const brktETH = getTokenDefinition({ symbol: "BRKTETH", chainId: 1, });
	const addNotification = useAddNotification();

	const handleAddToken = async () => {

		try {
			
			const ethereum = window.ethereum;
			
			if(ethereum) {
				addNotification({
					title: "Add brktETH token",
					message: "Please open your wallet to add token",
					type: "success",
					status: "success",
					secondaryAction: {
						label: "Dismiss",
						onClick: () => console.log("Notification dismissed"),
					},
				});

				await ethereum.request({
					method: "wallet_watchAsset",
					params: {
						type: "ERC20",
						options: {
							address: brktETH.address,
							symbol: "brktETH",
							decimals: 18,
						},
					},
				});
			}
		
		}
		catch (error) {

			console.error("Error adding token to MetaMask:", error);
		}

	};

	if(!ready || anonymous)
		return null;

	return (
		<BrkEthValueContainer>
			<Text size="sm" color="paragraph">
				{(brkt_conv_rate * eth_price).toLocaleString("en-us", {
					currency: "USD",
					style: "currency",
				})}
			</Text>
			<Button
				label={ <Text size="sm" color="paragraph">brktETH</Text> }
				variant="outline"
				size="sm"
				ml={"5px"}
				mr="5px"
				onClick={handleAddToken}
			/>
			<Text size="sm" as="span" color="surface_on">
				≈ {brkt_conv_rate.toFixed(5)} ETH
			</Text>
		</BrkEthValueContainer>
	);

};


export const PageHeader = ( {
	customHeader,
	description,
	icon,
	right,
	selector,
	title,
}: PageHeaderProps ) => {
	themed();

	if(customHeader) {
		return (
			<PageHeaderContainer>
				{customHeader}
				<SettingsContainer>
					<BrkEthValue />
					<SettingsBar />
				</SettingsContainer>
			</PageHeaderContainer>
		);
	}

	return (
		<PageHeaderContainer>
			<TitleContainer> 
				<IconContainer>{icon}</IconContainer>
				<HorizPageHeaderContainer>
					<Text variant="h5">{title}</Text>
					{ description && <Text size="md">{description}</Text> }
					{ selector && <Text size="md" color="paragraph">{selector}</Text> }
				</HorizPageHeaderContainer>
			</TitleContainer>
			<SettingsContainer>
				{ globalThis.location.pathname === "/get-brkteth" && <BrkEthValue /> }
				<SettingsBar />
				<WalletStoreConnector />
			</SettingsContainer>
			{right && <RightWrapper>{right}</RightWrapper>}
		</PageHeaderContainer>
	);

};



const PageHeaderContainer = styled(FlexStream)`
	justify-content: space-between;
	max-height: 60px;
	align-items: center;
`;


const HorizPageHeaderContainer = styled(FlexStream)`
	justify-content: space-between;
	gap: 2rem;
	max-height: 60px;
`;



const TitleContainer = styled(FlexStream)`
	gap: 12px;
	margin-right: auto;
	align-items: center;
`;

const IconContainer = styled(Flow)`
	background-color: ${() => getTheme().surface_container_high};
	color: ${() => getTheme().primary};
	border-radius: 8px;
	width: 44px;
	height: 44px;
	transition: background-color 0.3s ease;
`;

const SettingsContainer = styled(Div)`
	display: none;
	@media(min-width: 1024px) {
		display: flex;
		align-items: center;
		margin-left: auto;
	}
`;

const BrkEthValueContainer = styled(Stream)`
	align-items: center;
	margin-left: 2rem;
`;

const RightWrapper = styled(FlexStream)`
	justify-content: flex-end;
	gap: 1rem;
`;
